import React from 'react';
import Card from '../ui/Card';
import { Folder, Play, Building2, Tag } from 'lucide-react';
import { ProjectTableData } from '../../hooks/useProjectManagement';

interface ProjectStatsProps {
    projects: ProjectTableData[];
    fmeaItemsCount: number;
}

export const ProjectStats: React.FC<ProjectStatsProps> = ({ projects, fmeaItemsCount }) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <Card className="p-4">
                <div className="flex items-center justify-between">
                    <div>
                        <p className="text-xs text-text-secondary uppercase font-bold">Total Projects</p>
                        <p className="text-2xl font-bold text-text-primary">{projects.length}</p>
                    </div>
                    <Folder className="text-primary" size={32} />
                </div>
            </Card>
            <Card className="p-4">
                <div className="flex items-center justify-between">
                    <div>
                        <p className="text-xs text-text-secondary uppercase font-bold">Active Projects</p>
                        <p className="text-2xl font-bold text-green-600">
                            {projects.filter(p => p.status === 'active').length}
                        </p>
                    </div>
                    <Play className="text-green-600" size={32} />
                </div>
            </Card>
            <Card className="p-4">
                <div className="flex items-center justify-between">
                    <div>
                        <p className="text-xs text-text-secondary uppercase font-bold">Customers</p>
                        <p className="text-2xl font-bold text-blue-600">
                            {new Set(projects.map(p => p.customer).filter(c => c && c !== 'Unassigned')).size}
                        </p>
                    </div>
                    <Building2 className="text-blue-600" size={32} />
                </div>
            </Card>
            <Card className="p-4">
                <div className="flex items-center justify-between">
                    <div>
                        <p className="text-xs text-text-secondary uppercase font-bold">Total FMEA Items</p>
                        <p className="text-2xl font-bold text-purple-600">
                            {fmeaItemsCount}
                        </p>
                    </div>
                    <Tag className="text-purple-600" size={32} />
                </div>
            </Card>
        </div>
    );
};
